import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatCurrency, getAlert, getDataWithComp } from "./SamuiUtils";
import { formatDateAndTime } from "./DateUtils";

const ExportInventories = async (data) => {
    if (!Array.isArray(data) || data.length === 0) {
        return getAlert("FAILED", "ไม่มีข้อมูลสินค้าคงเหลือ");
    }

    try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าคงเหลือ");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        // เพิ่มข้อมูล
        data.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าคงเหลือ.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
};

const ExportInventoriesWarehouse = async (data) => {
    try {
        const opt = (localStorage.getItem("stc-item-option") || "0").toString();

        let source = Array.isArray(data) && data.length > 0
            ? data
            : await getDataWithComp("API_1101_WH_ITEM_ONHAND", "ORDER BY Item_Code ASC");

        if (!Array.isArray(source) || source.length === 0) {
            const whList = await getDataWithComp(
                "Tb_Set_WH",
                "AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC"
            );
            if (Array.isArray(whList) && whList.length > 0) {
                const allByWh = await Promise.all(
                    whList.map((wh) =>
                        getDataWithComp(
                            "API_1101_WH_ITEM_ONHAND",
                            `AND WH_Id = ${wh.WH_Id} ORDER BY Item_Code ASC`
                        )
                    )
                );
                source = allByWh
                    .filter(Array.isArray)
                    .flat();
            }
        }

        const filtered = Array.isArray(source) ? source.filter((item) => {
            const onhand = parseFloat(item?.Item_Onhand) || 0;
            switch (opt) {
                case "0": // > 0
                    return onhand > 0;
                case "1": // >= 0
                    return onhand >= 0;
                case "2": // = 0
                    return onhand === 0;
                case "3": // < 0
                    return onhand < 0;
                case "4": // all
                default:
                    return true;
            }
        }) : [];

        // Guard: if still empty after attempts
        if (!Array.isArray(filtered) || filtered.length === 0) {
            return getAlert("FAILED", "ไม่มีข้อมูลตามเงื่อนไขที่เลือก");
        }

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("สินค้าคงเหลือแยกตามคลัง");

        // เพิ่ม Header พร้อมกำหนดสไตล์
        worksheet.columns = [
            { header: "รหัสสินค้า", key: "Item_Code", width: 15 },
            { header: "ชื่อสินค้า", key: "Item_Name", width: 30 },
            { header: "คงเหลือ", key: "Item_Onhand", width: 15 },
            { header: "คลังสินค้า", key: "WH_Name", width: 20 },
            { header: "รายการล่าสุด", key: "Last_STC_Date", width: 25 },
        ];

        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true, color: { argb: "FFFF0000" } }; // ตัวหนังสือสีแดง
            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "FFFFFF00" }, // สีเหลือง
            };
            cell.alignment = { vertical: "middle", horizontal: "center" }; // จัดตำแหน่งกลาง
        });

        filtered.forEach((item) => {
            worksheet.addRow({
                Item_Code: item.Item_Code,
                Item_Name: item.Item_Name,
                Item_Onhand: formatCurrency(item.Item_Onhand),
                WH_Name: item.WH_Name,
                Last_STC_Date: formatDateAndTime(item.Last_STC_Date),
            });
        });

        // บันทึกไฟล์
        const buffer = await workbook.xlsx.writeBuffer();
        saveAs(new Blob([buffer]), "สินค้าคงเหลือแยกตามคลัง.xlsx");
    } catch (error) {
        console.error("Error exporting inventories:", error);
        getAlert("FAILED", "ไม่สามารถ Export ข้อมูลได้");
    }
};

export { ExportInventories, ExportInventoriesWarehouse };